<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Strength of Relationship</span>
            <el-button class="white-btn" size="small" @click="save" :loading="loading" :disabled="loading || !hasChanges">
                Save
            </el-button>
        </template>

        <el-form label-position="top" class="demo-ruleForm">
            <el-form-item label="Strength of Relationship">
                <el-select v-model="form.relationship_strength" placeholder="Select" style="width: 100%" clearable>
                    <el-option
                        v-for="option in relationshipOptions"
                        :key="option"
                        :label="option"
                        :value="option"
                    />
                </el-select>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
import {
    ElCard, ElButton, ElForm, ElFormItem, ElSelect, ElOption
} from 'element-plus'

const RELATIONSHIP_OPTIONS = ['High', 'Medium', 'Low'];

export default {
    name: "EnquiryRelationshipStrength",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElCard, ElButton, ElForm, ElFormItem, ElSelect, ElOption },
    data() {
        return {
            loading: false,
            relationshipOptions: RELATIONSHIP_OPTIONS,
            form: {
                relationship_strength: '',
            },
        }
    },
    computed: {
        hasChanges() {
            return (this.form.relationship_strength || '') !== (this.enquiry?.relationship_strength || '');
        }
    },
    watch: {
        enquiry: {
            immediate: true,
            handler(value) {
                this.form.relationship_strength = value?.relationship_strength || '';
            }
        }
    },
    methods: {
        save() {
            if (!this.hasChanges || this.loading) {
                return;
            }

            let currentObj = this;
            currentObj.loading = true;
            axios.post('/enquiry/saverelationshipnextstep?id=' + this.enquiry.id, {
                section: 'relationship',
                relationship_strength: this.form.relationship_strength || null,
            }).then(function (response) {
                toastr.success(response.data.message || 'Updated successfully.');
                currentObj.$emit('saved');
                currentObj.loading = false;
            }).catch(function (error) {
                currentObj.loading = false;
                const message = error?.response?.data?.message || 'Something Wrong try again.';
                toastr.error(message);
            });
        }
    }
}
</script>

<style scoped>
</style>
